import { BasicLayout } from '../../components/BasicLayout';
import InstructionsSent from './InstructionsSent';

const InstructionsSentScene = () => {
  return (
    <BasicLayout>
      <InstructionsSent />
    </BasicLayout>
  );
};

export default InstructionsSentScene;
